import React, { useContext, useEffect, useState } from "react";
import { Upload, Image, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { nanoid } from "nanoid";
import { uploadDocumentAffaire } from "../api/geoprod";
import GlobalContext from "../context/GlobalContext";



const CustomUpload = ({
  field,
  multiple = false,
  accept = "*",
  id_affaire,
  id_type_doc,
}) => {
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const { form } = useContext(GlobalContext);
  const handleCustomRequest = async ({
    file,
    onSuccess,
    onError,
  }) => {
    const formData = new FormData();

    const newFileName = `${field.title.split("-")[0] + nanoid(12)}.${file.name
      .split(".")
      .pop()}`;
    const renamedFile = new File([file], newFileName, { type: file.type });

    formData.append("id_affaire", id_affaire);
    formData.append("id_type_doc", id_type_doc);
    formData.append("name_doc", field.name);
    formData.append("file[]", renamedFile);
    formData.append("key", field.name);

    try {
      const data = await uploadDocumentAffaire(formData);

      const fileUrl = data.data.path;
      form.setFieldsValue({
        ...form.getFieldsValue(),
        [field.name]: fileUrl,
      });

      setFileList((prevList) =>
        prevList.map((item) =>
          item.uid === file.uid
            ? { ...item, url: fileUrl, status: "done" }
            : item
        )
      );

      onSuccess(data);
    } catch (err) {
      console.error(err);
      message.error("Échec de l'envoi");
      onError(err);
    }
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(multiple ? newFileList : newFileList.slice(-1));
  };

  const handlePreview = async (file) => {
    const url = file.url || (file.response && file.response.url);
    if (url) {
      window.open(url, '_blank');
    } else {
      message.warning("Aucun lien de prévisualisation disponible.");
    }
  };
  

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>{field?.buttonName || "Téléverser"}</div>
    </div>
  );
  const extractFileName = (url) => {
    if(url){
      return url?.split('/').pop().split('?')[0]; // Simple

    }
  };
  
const getRcenetFiles=()=>{
  const initialValues = form.getFieldsValue();
  const fileUrl = initialValues[field.name];

  if (fileUrl) {
    setFileList([
      {
        uid: '-1',
        name: extractFileName(fileUrl),
        status: 'done',
        url: fileUrl,
      },
    ]);
  }
}
  useEffect(() => {
    getRcenetFiles()
  }, []);
  
  

  return (
    <>
      <div style={{ width: "100%" }}>
        <Upload
          customRequest={handleCustomRequest}
          listType="picture-card"
          fileList={fileList}
          onChange={handleChange}
          onPreview={handlePreview}
          multiple={multiple}
          accept={accept}
        >
          {(!multiple && fileList.length >= 1) ||
          (multiple && fileList.length >= 8)
            ? null
            : uploadButton}
        </Upload>
      </div>

      {previewImage && (
        <Image
          wrapperStyle={{ display: "none" }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </>
  );
};

export default CustomUpload;
